import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { AiOutlineHome, AiOutlineUser, AiOutlineFundProjectionScreen } from 'react-icons/ai'
import { CgFileDocument } from 'react-icons/cg'

function NavBar() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const location = useLocation()

  const links = [
    { to: '/', label: 'Home', icon: <AiOutlineHome /> },
    { to: '/about', label: 'About', icon: <AiOutlineUser /> },
    { to: '/project', label: 'Projects', icon: <AiOutlineFundProjectionScreen /> },
    { to: '/resume', label: 'Resume', icon: <CgFileDocument /> },
  ]

  return (
    <div className="navbar-wrapper">
      <div className="navbar-pill">
        <Link to="/" className="navbar-brand-pill">
          amaan<span>.dev</span>
        </Link>

        {links.map(link => (
          <Link
            key={link.to}
            to={link.to}
            className={`nav-pill-link ${location.pathname === link.to ? 'active' : ''}`}
            onClick={() => setMobileOpen(false)}
          >
            {link.label}
          </Link>
        ))}

        <button
          className="navbar-mobile-toggle"
          onClick={() => setMobileOpen(o => !o)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <div className={`navbar-mobile-menu ${mobileOpen ? 'open' : ''}`}>
        {links.map(link => (
          <Link
            key={link.to}
            to={link.to}
            className={`nav-pill-link ${location.pathname === link.to ? 'active' : ''}`}
            onClick={() => setMobileOpen(false)}
          >
            {link.icon} {link.label}
          </Link>
        ))}
      </div>
    </div>
  )
}

export default NavBar
